import { InjectionToken } from '@angular/core';
import { ShimmerOptions } from './shimmer.model';

export const SHIMMER_OPTIONS = new InjectionToken<ShimmerOptions>(
  'Default config for shimmer',
  {
    factory: () => {
      return {
        width: '100%',
        height: '16px',
        borderRadius: '8px',
        colors: {
          background: '#edeef1',
          1: '#edeef1',
          2: '#f6f7f8',
          3: '#f4f4f4',
          4: '#edeef1',
        },
        duration: '1s',
      };
    },
  }
);
